import React, { useState,useRef } from "react";
import Tooltip from "@tippyjs/react";
import MaterialTable, {
  MTableToolbar,
} from "material-table";
import { ToastContainer } from "react-toastify";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import AsyncSelect from "react-select/async";
import _ from "lodash";
import axios from "axios";

import Helper from "../../Helper";
import { getTrans as t } from "../../Localization/translations";
import authHeader from "../../services/auth-header";
import { API } from "../../backend";

function AccountingPeriods() {
  const tableRef = useRef();
  const [data, setData] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const [selectedValue2, setSelectedValue2] = useState(null);
  const [inputvalue2, setValue2] = useState("");

  const [state1, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });

  const handelInputChange2 = (value1) => {
    setValue2(value1);
  };

  const handelChange2 = (value1) => {
    setSelectedValue2(value1);
  };

  const loadOptions2 = async (inputValue2) => {
    if (inputValue2 !== "") {
      const response = await axios.get(
        API + `accounting/periods/filter/?period_year=${inputValue2}`,
        { headers: authHeader() }
      );
      return response.data.data;
    }
  };

  const handleClear = () => {
    setSelectedValue(null);
    setSelectedValue2(null);
    tableRef.current.onQueryChange();
  };
  let period_year = "";
  let calendar_name = "";

  const handelSearch = () => {
    tableRef.current.onQueryChange();
  };
  const STATUS_PERIODS = {
    O: "Open",
    C: "Closed",
    N: "Not Opened",
    F: "Future Open",
  };


  return (
    <div className="container-fluid py-4 pt-2">
      <div className="row py-2 mt-2">
        <ToastContainer />
        <div className="col-md-12">
          <div className=" mb-0">
            <div className="header pb-0">
              <div className="d-lg-flex">
                <div>
                  <h5 className="mb-3 tc">{t("Accounting Periods")}
                  </h5>
                </div>
              </div>
            </div>
            <div className="body">
              <div className="card">
                <div className="card-body">
                  <div className="col-md-10">
                    <div className=" row">
                      <div className="col-xl-3">
                        <label className="col-lg-6 col-form-label">
                          {t("Calendar Name")}{" "}
                          <Tooltip content={t("CalendarName_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                      </div>
                      <div className="col-xl-3">
                        <span className="col-lg-6 view-label p">
                          Default Calendar
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="p-0">
                <MaterialTable
                  tableRef={tableRef}
                  style={{
                    padding: "0.5rem 0.5rem",
                    backgroundColor: "var(--bs-table-bg)",
                    borderBottomWidth: "1px",
                    boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                  }}
                  title={<h5 className="mb-0 tc">{t("")}</h5>}
                  columns={[
                    {
                      title: `${t("Period Name")}`,
                      field: "period_name",
                      editable: "never",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("Period Name")}</div>
                          <div>{rowData.period_name}</div>
                        </>
                      ),

                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Start Date")}`,
                      field: "start_date",
                      editable: "never",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("Start Date")}</div>
                          <div>{Helper.DateNormal(rowData.start_date)}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("End Date")}`,
                      field: "end_date",
                      editable: "never",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("End Date")}</div>
                          <div>{Helper.DateNormal(rowData.end_date)}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Status")}`,
                      field: "status",
                      lookup: STATUS_PERIODS,
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("Status")}</div>
                          <div>{STATUS_PERIODS[rowData.status]}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                  ]}
                  data={(query) =>
                    new Promise((resolve, reject) => {
                      if (selectedValue2 && selectedValue) {
                        calendar_name = selectedValue.calendar_name;
                        period_year = selectedValue2.period_year;
                      } else if (selectedValue) {
                        calendar_name = selectedValue.calendar_name;
                      } else if (selectedValue2) {
                        period_year = selectedValue2.period_year;
                      }

                      let url = API + "accounting/periodsview/?";
                      url += "per_page=" + query.pageSize;
                      url += "&page=" + (query.page + 1);
                      url += "&search=" + query.search;
                      url += `&calendar_name=${calendar_name !== "" ? calendar_name : ""
                        }`;
                      url += `&period_year=${period_year !== "" ? period_year : ""
                        }`;
                      fetch(url, { headers: authHeader() })
                        .then((response) => response.json())
                        .then((result) => {
                          resolve({
                            data:
                              query.orderBy && query.orderDirection
                                ? _.orderBy(
                                  result.data,
                                  [query.orderBy.field],
                                  [query.orderDirection]
                                )
                                : result.data,
                            page: result.page - 1,
                            totalCount: result.total,
                          });
                        });
                    })
                  }
                  editable={{
                    onRowUpdate: (newData, oldData) =>
                      new Promise((resolve, reject) => {
                        const updatedStatusData = { status: newData.status };
                        axios
                          .post(
                            API + `accounting/period-edit/${oldData.id}/`,
                            updatedStatusData,
                            { headers: authHeader() }
                          )
                          .then((response) => {
                            const dataUpdate = [...data];
                            const index = oldData.tableData.id;
                            dataUpdate[index] = {
                              ...oldData,
                              ...updatedStatusData,
                            };
                            setData([...dataUpdate]);
                            resolve();
                          })
                          .catch((error) => {
                            console.error("Error updating status:", error);
                            reject();
                          });
                      }),
                  }}
                  components={{
                    Toolbar: (props) => (
                      <div className="MuiToolbar-root MTableToolbar-spacer-21  my-temp-class">
                        <MTableToolbar {...props} />
                        <span
                          onClick={() => setState({ isPaneOpen: true })}
                          style={{
                            color: "#b4b7c5",
                            paddingRight: "10px",
                            cursor: "pointer",
                          }}
                        >
                          <img
                          alt=""
                            src={
                              process.env.PUBLIC_URL +
                              "/static/images/ic-filter.svg"
                            }
                          />
                        </span>
                      </div>
                    ),
                  }}
                  options={{
                    headerStyle: {
                      backgroundColor: "white",
                      color: "#245C7F",
                      fontSize: 12,
                    },
                    rowStyle: (rowData, index) => {
                      if (index % 2) {
                        return { backgroundColor: "#fff" };
                      }
                    },
                    sorting: true,
                    search: false,
                    toolbar: true,
                    paging: true,
                    pageSize: 10, // make initial page size
                    emptyRowsWhenPaging: false, // To avoid of having empty rows
                    pageSizeOptions: [10, 15, 20, 50],
                    paginationType: "stepped",
                    showFirstLastPageButtons: false,
                    actionsColumnIndex: -1,
                  }}
                />
                <SlidingPane
                  className="some-custom-class"
                  overlayClassName="some-custom-overlay-class"
                  isOpen={state1.isPaneOpen}
                  title="Filter By"
                  subtitle=""
                  onRequestClose={() => {
                    setState({ isPaneOpen: false });
                  }}
                >
                  <div className="col-xl-12">
                    <div className="form-group row">
                      <label className="col-lg-12 col-form-label">
                        {t("Year")}
                      </label>
                      <div className="col-lg-12">
                        <AsyncSelect
                          defaultOptions
                          isClearable
                          placeholder={t("Search for Year(%for All)")}
                          value={selectedValue2}
                          getOptionLabel={(e) => e.period_year}
                          getOptionValue={(e) => e.period_year}
                          loadOptions={loadOptions2}
                          onInputChange={handelInputChange2}
                          onChange={handelChange2}
                        ></AsyncSelect>
                      </div>
                      <input type="hidden" id="contract_status" value="" />
                    </div>
                  </div>
                  <div className="col-xl-12">
                    <div className="form-group row">
                      <div
                        className="col-lg-12 text-left"
                        style={{ marginTop: "30px" }}
                      >
                        <button
                          type="button"
                          className="clearReceipt btn bg-gradient-secondary btn-m ms-auto mb-0"
                          onClick={handleClear}
                        >
                          {t("Reset")}
                        </button>
                        &nbsp;&nbsp;
                        <button
                          type="button"
                          className="filter add btn btn-primary btn-m ms-auto mb-0"
                          onClick={handelSearch}
                        >
                          {t("Apply")}
                        </button>
                        &nbsp;&nbsp;
                      </div>
                    </div>
                  </div>
                </SlidingPane>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccountingPeriods;
